<script setup lang="ts">
/* Types */
import { TabTypes } from '@/types/components/basket-time.types'

const model = defineModel<TabTypes>()
</script>

<template>
  <div class="basket-time-tabs">
    <the-tabs v-model="model">
      <the-tabs-item :value="TabTypes.FAST" :ripple="false">
        Как можно скорее
      </the-tabs-item>

      <the-tabs-item :value="TabTypes.DELIVERY_ON_TIME" :ripple="false">
        Ко времени
      </the-tabs-item>
    </the-tabs>
  </div>
</template>
